import { createApp, provide, h } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import { loadAllPlugins } from './plugins'
import '@/assets/iconfont/iconfont.css'
import '@/styles/index.scss'
import 'normalize.css'
import '@/permission'
import GC from './components'
import { ApolloClients } from '@vue/apollo-composable'
import { baseClient, dmzClient } from './apollo-client'
import * as Sentry from '@sentry/vue'

const app = createApp({
  setup () {
    provide(ApolloClients, {
      default: baseClient,
      dmz: dmzClient
    })
  },
  render: () => h(App)
})

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 加载所有插件
loadAllPlugins(app)
app.use(store).use(router).use(GC).mount('#app')
